module.exports = __webpack_public_path__ + "static/media/webVideoText.33afedf3.svg";